(function () {
  if (!window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var html = document.documentElement;

  var derniers = {};
  function remplir(jauge) {
    if (jauge.dataset.fkRempli) return;
    jauge.dataset.fkRempli = '1';
    var cible = jauge.style.width;
    var cle = jauge.closest('cart-drawer') ? 'tiroir' : 'page';
    var depart = derniers[cle] || '0%';
    derniers[cle] = cible;
    if (!cible || depart === cible) return;
    jauge.style.transition = 'none';
    jauge.style.width = depart;
    void jauge.offsetWidth;
    jauge.style.transition = '';
    jauge.style.width = cible;
  }
  document.querySelectorAll('.fk-livraison__jauge').forEach(remplir);
  new MutationObserver(function (liste) {
    liste.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches('.fk-livraison__jauge')) remplir(n);
        n.querySelectorAll('.fk-livraison__jauge').forEach(remplir);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  function relacher() {
    setTimeout(function () {
      document.querySelectorAll('.fk-touche').forEach(function (t) {
        t.classList.remove('fk-touche');
      });
    }, 280);
  }
  document.addEventListener('touchstart', function (e) {
    var tuile = e.target.closest && e.target.closest('.fk-tuile');
    if (tuile) tuile.classList.add('fk-touche');
  }, { passive: true });
  document.addEventListener('touchend', relacher, { passive: true });
  document.addEventListener('touchcancel', relacher, { passive: true });

  if (!('IntersectionObserver' in window)) return;
  var observateur = new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (!e.isIntersecting) return;
      (e.target.fkCible || e.target).classList.add('fk-vu');
      observateur.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  var hauteur = window.innerHeight;
  function suivre(selecteur, classe, decale) {
    document.querySelectorAll(selecteur).forEach(function (el, i) {
      if (el.getBoundingClientRect().top < hauteur * 0.92) return;
      el.classList.add(classe);
      if (decale) el.style.transitionDelay = (i % 2) * 90 + 'ms';
      var guet = classe === 'fk-ecrit' ? el.parentElement : el;
      guet.fkCible = el;
      observateur.observe(guet);
    });
  }
  html.classList.add('fk-anim');
  suivre('.fk-ecran:not(.fk-ecran--plein) .fk-ecran__inner, .fk-tuile__texte, .newsletter__wrapper, .collapsible-content__wrapper', 'fk-apparait', false);
  suivre('.product-grid .grid__item', 'fk-apparait', true);
  suivre('.footer-block__details-content em', 'fk-ecrit', false);

  var logoCalques = document.querySelectorAll('.header__heading-logo-wrapper');
  logoCalques.forEach(function (enveloppe) {
    var bug1 = enveloppe.querySelector('.fk-logo-bug--1');
    var bug2 = enveloppe.querySelector('.fk-logo-bug--2');
    var rgb = enveloppe.querySelector('.fk-logo-bug--rgb');
    if (!bug1 || !bug2 || !rgb) return;
    function montrer(calque) {
      [bug1, bug2, rgb].forEach(function (c) { c.classList.remove('fk-logo-bug--on'); });
      if (calque) calque.classList.add('fk-logo-bug--on');
    }
    function acoup() {
      montrer(bug1);
      setTimeout(function () { montrer(rgb); }, 80);
      setTimeout(function () { montrer(bug2); }, 140);
      setTimeout(function () { montrer(null); }, 220);
      setTimeout(function () { montrer(bug1); }, 260);
      setTimeout(function () { montrer(null); planifier(); }, 300);
    }
    function planifier() {
      setTimeout(acoup, 4000 + Math.random() * 2000);
    }
    planifier();
  });
})();
